<template>
  <!-- 巡查区域 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <input
          type="file"
          id="riskFile"
          accept=".xls,.xlsx"
          @change="importPatrolRegion($event)"
        />
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="openAddPratrolRegion()"
          >添加</el-button
        >
        <el-button
          size="mini"
          type="danger"
          plain
          icon="el-icon-circle-close"
          @click="delPatrolRegion()"
          :disabled="deleteIdInfo.length == 0"
          >删除</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-bottom-right"
          @click="selectFileImport()"
          >导入</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-top-right"
          @click="exportPatrolRegion()"
          :disabled="dataList.content.length == 0"
          >导出</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-download"
          @click="
            $Common.fileDownloads(
              $store.state.select.downloadFileData.patrolRegionTemplate
            )
          "
          >下载模版</el-button
        >
         <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-download"
          @click="exportArea"

          >导入地点</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          size="mini"
          placeholder="请输入巡查区域"
          class="textInput"
          v-model.trim="requestParams.searchValue"
          clearable
        ></el-input>
        <el-input
          size="mini"
          placeholder="请输入二维码编号"
          class="textInput"
          v-model.trim="requestParams.codePictureNumber"
          clearable
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="dataList.content"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="patrolRegionaSelectionChange"
        >
          <el-table-column type="selection" width="40">
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="regionalPatrolSite"
            label="巡查区域"
            align="center"
          >
            <!-- <template v-slot="scope">
              <div
                class="col-sm-12"
                @click="getOnePatrolRegion(scope.row.regionalPatrolId)"
              >
                {{ scope.row.regionalPatrolSite }}
              </div>
            </template> -->
          </el-table-column>

          <el-table-column label="已关联任务" align="center">
            <template v-slot="scope">
              <div class="task" v-if="scope.row.dailyTaskToolList.length > 0">
                <div
                  class="task-info"
                  v-for="item in scope.row.dailyTaskToolList"
                  :key="item.dailyTaskId"
                >
                  <span class="task-name">{{ item.dailyTaskName }}</span
                  ><span class="comma">，</span>
                </div>
              </div>
              <div v-else>暂无任务</div>
            </template>
          </el-table-column>
          <el-table-column label="二维码图像信息" align="center">
            <template v-slot="scope">
              <div class="demo-image__preview" style="text-align:center">
                <el-image
                  style="width: 60px; height: 60px"
                  :src="$store.state.config.fileUrl + scope.row.codePictureUrl"
                  :preview-src-list="[
                    $store.state.config.fileUrl + scope.row.codePictureUrl
                  ]"
                >
                </el-image>
                <div>{{ scope.row.codePictureNumber }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="qrCodeType" label="二维码类型" align="center" width="120">
            <template v-slot="scope">
              {{ $store.state.select.qrCodeType[scope.row.qrCodeType].name }}
            </template>
          </el-table-column>

          <el-table-column prop="addtime" label="创建日期" align="center" width="120">
            <template v-slot="scope">
              {{ $Common.dateFormatDate(scope.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template v-slot="scope">
                <el-link
                class="link_box"
                type="primary"
                @click="getOnePatrolRegion(scope.row.regionalPatrolId)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                @click="delPatrolRegion(scope.row.regionalPatrolId)"
                :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="patrolAreaPage"
          :current-page="requestParams.pageNum"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="dataList.total"
        >
        </el-pagination>
      </div>
      <!-- 新增巡查区域 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        width="800px"
        title="新增巡查区域"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-2 control-label">地点名称</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="addPatrolRegionData.regionalPatrolSite"
                  placeholder="地点名称"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">巡查二维码类型</label>
              <div class="col-sm-10">
                <el-radio-group
                  v-model="addPatrolRegionData.qrCodeType"
                  size="mini"
                >
                  <el-radio border :label="0">静态二维码（固定不变）</el-radio>
                  <el-radio border :label="1"
                    >动态二维码（巡查二维码每小时更新一次）</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div
              class="form-group"
              v-show="addPatrolRegionData.qrCodeType == 1"
            >
              <label class="col-sm-2 control-label">弹性时间(分钟)</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  v-model="addPatrolRegionData.flexTime"
                  placeholder="弹性时间(分钟)"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">二维码编号</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  maxlength="20"
                  v-model="addPatrolRegionData.codePictureNumber"
                  placeholder="二维码编号"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">巡查NFC</label>
              <div class="col-sm-10">
                <el-radio-group v-model="addPatrolRegionData.nfc" size="mini">
                  <el-radio border :label="0">关闭（默认）</el-radio>
                  <el-radio border :label="1">开启</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="form-group" v-show="addPatrolRegionData.nfc == 1">
              <label class="col-sm-2 control-label">NFC编码</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  v-model="addPatrolRegionData.nfcContent"
                  placeholder="NFC编码"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"
                >巡查任务类型</label
              >
              <div class="col-sm-10">
                <div class="col-sm-12">
                  常规检查
                </div>
                <el-divider></el-divider>
                <!-- <div class="col-sm-12">
                                <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="pushInspectionCate()">添加检查事项</el-button>
                                <el-button type="primary" size="mini" plain icon="el-icon-s-order" @click="openInspectionItems()">预设事项</el-button>
                            </div>
                            <div class="inspection_cate_list" v-for="(value,index) in addPatrolRegionData.routineInspectionContent" :key="index">
                                <div class="col-sm-8">
                                    <input type="text" v-model="addPatrolRegionData.routineInspectionContent[index]"  class="form-control" placeholder="请输入名称"  @input="updateInspectionCate(index,$event)"  >
                                </div>
                                <div class="col-sm-4">
                                    <el-button type="danger" plain size="mini" @click="deleteInspectionCate(index)">删除</el-button>
                                </div>
                            </div> -->
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  icon="el-icon-plus"
                  @click="pushInspectionCate()"
                  >添加检查事项</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  icon="el-icon-s-order"
                  @click="openInspectionItems()"
                  >预设事项</el-button
                >
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <div
                  class="inspection_cate_list"
                  v-for="(value,
                  index) in addPatrolRegionData.routineInspectionContent"
                  :key="index"
                >
                  <div class="col-sm-8 nopadding">
                    <input
                      type="text"
                      v-model="
                        addPatrolRegionData.routineInspectionContent[index]
                      "
                      class="form-control"
                      placeholder="请输入名称"
                      @input="updateInspectionCate(index, $event)"
                    />
                  </div>
                  <div class="col-sm-4">
                    <el-button
                      type="danger"
                      plain
                      size="mini"
                      @click="deleteInspectionCate(index)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <span class="" slot="footer">
          
            <el-button
              v-show="showBox.addOrUpdateStatusOne == 1"
              type="primary"
              @click="addPatrolRegion"
              >确定添加</el-button
            >
            <el-button
              v-show="showBox.addOrUpdateStatusOne == 2"
              type="primary"
              @click="setPatrolRegion"
              >确定修改</el-button
            >
            <el-button @click="dialog = false">返回</el-button>
      
        </span>
      </el-dialog>
      <!-- 选择检查事项 -->
      <el-dialog
        title="选择检查事项"
        :visible.sync="showBox.InspectionItemsBox"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="showBoxContent"
      >
        <div class="row height100">
          <div
            class="col-sm-12 inspection_items_box"
            v-show="showBox.InspectionItemsContent == 1"
          >
            <el-tree
              @check-change="selectInspectionItems"
              :data="getSaveData.inspectionItemsOne.dataList"
              :default-checked-keys="getSaveData.selectArr"
              show-checkbox
              node-key="id"
              ref="treeOne"
              highlight-current
            >
            </el-tree>
          </div>
          <div
            class="col-sm-12 inspection_items_box"
            v-show="showBox.InspectionItemsContent == 2"
          >
            <el-tree
              @check-change="selectInspectionItems"
              :data="getSaveData.inspectionItemsTwo.dataList"
              :default-checked-keys="getSaveData.selectArr"
              show-checkbox
              node-key="id"
              ref="treeTwo"
              highlight-current
            >
            </el-tree>
          </div>
          <div class="col-sm-12 check_object_bottom">
            <div class="col-sm-6 text-left">
              <el-button size="mini" @click="showBox.InspectionItemsContent = 1"
                >系统检查项一</el-button
              >
              <el-button size="mini" @click="showBox.InspectionItemsContent = 2"
                >系统检查项二</el-button
              >
            </div>

            <div class="col-sm-6 text-left">
              <el-button size="mini" @click="determineInspect">确定</el-button>
              <el-button size="mini" @click="showBox.InspectionItemsBox = false"
                >取消</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <new-file-upload ref="fileUpload" @searchData="searchData"></new-file-upload>
  </div>
</template>

<script>
import NewFileUpload from '@/components/NewFileUpload.vue'
export default {
  name: "",
  components: {NewFileUpload},
  props: {},
  data() {
    return {
      dialog: false,
      rightSonMenu: 1,
      // 请求数据
      requestParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        searchValue: "",
        codePictureNumber: "", // 二维码编号
        dailyTaskName: "", // 巡查任务
        regionalPatrolSite: "", // 巡查点
        supervisorsStatus: "" // 巡查状态
      },
      // 数据列表
      dataList: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        total: 0, // 总条数
        totalPages: 0, // 总页数
        content: [] // 数据列表
      },
      // 删除数据
      deleteIdInfo: [],
      // 显示框
      showBox: {
        // 预设事项框
        InspectionItemsBox: false,
        // 预设事项1
        InspectionItemsContent: 1,
        addOrUpdateStatusOne: 1, //1添加，2修改
        showText: "新增巡查区域",
        choiceInspectTask: false // 选择检查任务
      },
      // 新增巡查区域数据
      addPatrolRegionData: {
        regionalPatrolId: "",
        regionalPatrolSite: "", //巡查区域
        codePictureNumber: "", //二维码编号
        qrCodeType: 0, //二维码类型 0静态 1动态
        flexTime: 5, //弹性时间(分钟)
        schoolId: this.$store.state.schoolId, //学校id
        nfc: 0, //0不开启 1开启
        nfcContent: "", //NFC编码
        routineInspectionContent: [] //检查项内容 用逗号隔开传入一串字符
      },

      // 查询保存的数据
      getSaveData: {
        inspectionItemsOne: {
          dataList: []
        },
        inspectionItemsTwo: {
          dataList: []
        },

        selectArr: [],
        selectArrName: []
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    //判断是否禁用
    // selectable(row, index) {
    //   // console.log(row)
    //   if (row.taskType == 1) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    // 选择检查事项
    selectInspectionItems(data, checked, indeterminate) {
      // console.log(data)
      if (checked == true) {
        if (data.selectPath == 2) {
          this.getSaveData.selectArr.push(data.id);
          this.getSaveData.selectArrName.push(data.label);
        } else {
          var dataListOne = data.children;
          for (var dataListKey in dataListOne) {
            this.getSaveData.selectArr.push(dataListOne[dataListKey].id);
            this.getSaveData.selectArrName.push(dataListOne[dataListKey].label);
          }
        }
      } else {
        if (data.selectPath == 2) {
          var dataArr = this.getSaveData.selectArr;
          var dataArrName = this.getSaveData.selectArrName;
          for (var newData in dataArr) {
            if (dataArr[newData] == data.id) {
              dataArr.splice(newData, 1);
              dataArrName.splice(newData, 1);
            }
          }

          this.getSaveData.selectArr = dataArr;
          this.getSaveData.selectArrName = dataArrName;
        } else {
          var dataArr = this.getSaveData.selectArr;
          var dataArrName = this.getSaveData.selectArrName;

          var dataListOne = data.children;
          for (var dataListKey in dataListOne) {
            for (var newData in dataArr) {
              if (dataArr[newData] == dataListOne[dataListKey].id) {
                dataArr.splice(newData, 1);
                dataArrName.splice(newData, 1);
              }
            }
          }
        }
      }

      // console.log(this.getSaveData.selectArr)
      // console.log(this.getSaveData.selectArrName)
    },
    // 确定选择检查事项
    determineInspect() {
      var selectArrName = this.getSaveData.selectArrName;
      var selectedData = this.addPatrolRegionData.routineInspectionContent;

      for (var newDataOne in selectArrName) {
        var testData = true;
        if (selectedData.length >= 1) {
          testData = false;
          for (var newDataTwo in selectedData) {
            if (selectArrName[newDataOne] == selectedData[newDataTwo]) {
              selectedData.splice(newDataOne, 1);
            }
          }
        }
        selectedData.push(selectArrName[newDataOne]);
      }

      this.addPatrolRegionData.routineInspectionContent = selectedData;
      this.showBox.InspectionItemsBox = false;
    },
    searchData() {
      this.requestParams.pageNum = 1;
      this.getQueryRegion();
    },
    // 巡查区域翻页
    patrolAreaPage(val) {
      this.requestParams.pageNum = val;
      this.getQueryRegion();
      console.log(`当前页: ${val}`);
    },

    // 日常巡查翻页
    dailyInspectionPage(val) {
      this.requestParams.pageNum = val;
      this.getDailyInspectionData();
      console.log(`当前页: ${val}`);
    },

    //选择要删除的巡查区域
    patrolRegionaSelectionChange(val) {
      var resId = [];
      val.forEach((element) => {
        resId.push(element.regionalPatrolId);
      });
      this.deleteIdInfo = resId;
    },
    // 导出巡查区域
    async exportPatrolRegion() {
      let req = {};
      if (this.deleteIdInfo.length == 0) {
        req = {
          schoolId: this.$store.state.schoolId
        };
      } else {
        req = {
          schoolId: Number(this.$store.state.schoolId),
          regionalPatrolIdList: this.deleteIdInfo
        };
      }
      this.$Common.exportData(req, "exportPatrolRegion", "巡查区域", true, ".zip");
    },
    // 删除巡查区域
    delPatrolRegion(redioid = "") {
      if (!redioid & (this.deleteIdInfo.length < 1)) {
        this.$message("请先选中您要删除的数据");
        return;
      }
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (redioid) {
            var requestData = {
              regionalPatrolId: redioid
            };
          } else {
            var requestData = {
              regionalPatrolId: this.deleteIdInfo.join(",")
            };
          }

          // console.log(requestData)
          // return false
          let res = await this.$Http.delPatrolRegion(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getQueryRegion();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 选择文件导入
    selectFileImport() {
      document.getElementById("riskFile").click();
    },
    // 导入巡查区域
    async importPatrolRegion() {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload
      };
      var newData = {
        schoolId: this.$store.state.schoolId,
        file: fileUpload
      };
      const loading = this.$loading({
        lock: true,
        text: "数据导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res = await this.$Http.importPatrolRegion(newData, true);
      // console.log(res)
      document.getElementById("riskFile").value = null;

      loading.close();
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功"
        });
        this.getQueryRegion();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 新增巡查区域
    async addPatrolRegion() {
      var newData = Object.assign({}, this.addPatrolRegionData);
      newData.routineInspectionContent = newData.routineInspectionContent.join(
        ","
      );
      // console.log(newData)
      // console.log(this.addPatrolRegionData)
      let res = await this.$Http.addPatrolRegion(newData, true);
      if (res&&res.code == 200) {
        this.$message({
          type: "success",
          message: "添加成功"
        });
        this.cancelForm();
        this.getQueryRegion();
      } else if (res&&res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res&&res.messsage
        });
      }
    },
    // 修改巡查区域
    async setPatrolRegion() {
      var setPatrolRegionData = Object.assign({}, this.addPatrolRegionData);
      setPatrolRegionData.routineInspectionContent = setPatrolRegionData.routineInspectionContent.join(
        ","
      );
      // console.log(setPatrolRegionData)
      // console.log(this.addPatrolRegionData)
      let res = await this.$Http.setPatrolRegion(setPatrolRegionData, true);
      // console.log(res)

      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功"
        });
        this.cancelForm();
        this.getQueryRegion();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // .常规检查-预设事项-系统检查项1
    async inspectionItemsOne() {
      let res = await this.$Http.inspectionItemsOne("");
      if (res.code == 200) {
        var inspectionItemsOne = [];
        for (var keyOne in res.data) {
          var newData = [];
          for (var keyTwo in res.data[keyOne].hiddencontents) {
            newData[keyTwo] = {
              id: "1_" + keyOne + keyTwo + 100,
              label: res.data[keyOne].hiddencontents[keyTwo].hiddenContent,
              selectPath: 2
            };
          }

          inspectionItemsOne[keyOne] = {
            id: "1_" + keyOne + 10,
            label: res.data[keyOne].headline,
            selectPath: 1,
            children: newData
          };
        }
        this.getSaveData.inspectionItemsOne.dataList = inspectionItemsOne;
        // console.log(this.getSaveData.inspectionItemsOne)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // .常规检查-预设事项-系统检查项2
    async inspectionItemsTwo() {
      let res = await this.$Http.inspectionItemsTwo("");
      if (res.code == 200) {
        var inspectionItemsTwo = [];
        for (var keyOne in res.data) {
          var newData = [];
          for (var keyTwo in res.data[keyOne].safetyContents) {
            newData[keyTwo] = {
              id: "2_" + keyOne + keyTwo + 100,
              label: res.data[keyOne].safetyContents[keyTwo].safetyContent,
              selectPath: 2
            };
          }

          inspectionItemsTwo[keyOne] = {
            id: "2_" + keyOne + 10,
            label: res.data[keyOne].safety,
            children: newData,
            selectPath: 1
          };
        }
        this.getSaveData.inspectionItemsTwo.dataList = inspectionItemsTwo;
        // console.log(this.getSaveData.inspectionItemsTwo)
        // this.getSaveData.inspectionItemsTwo = res.data
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取查询区域数据
    async getQueryRegion() {
      var newParamData = {
        schoolId: this.requestParams.schoolId,
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize,
        regionalPatrolSite: this.requestParams.searchValue,
        codePictureNumber: this.requestParams.codePictureNumber
      };

      let res = await this.$Http.getQueryRegion(newParamData);
      // console.log(res)
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.totalPages = res.data.pages;
        this.dataList.content = res.data.list;
        // console.log(this.dataList)
      } else if (res.code == 101) {
        this.dataList.pageSize = 20;
        this.dataList.pageNum = 1;
        this.dataList.total = 0;
        this.dataList.content = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 打开新增查询区域
    openAddPratrolRegion() {
      this.showBox.showText = "新增查询区域";
      this.showBox.addOrUpdateStatusOne = 1;
      this.addPatrolRegionData = {
        regionalPatrolId: "",
        regionalPatrolSite: "", //巡查区域
        codePictureNumber: "", //二维码编号
        qrCodeType: 0, //二维码类型 0静态 1动态
        flexTime: 5, //弹性时间(分钟)
        schoolId: this.$store.state.schoolId, //学校id
        nfc: 0, //0不开启 1开启
        nfcContent: "", //NFC编码
        routineInspectionContent: [] //检查项内容 用逗号隔开传入一串字符
      };

      this.dialog = true;
    },

    // 获取巡查区域详情
    async getOnePatrolRegion(id) {
      this.showBox.addOrUpdateStatusOne = 2;
      this.addPatrolRegionData.regionalPatrolId = id;
      // console.log(this.addPatrolRegionData.regionalPatrolId)
      var paramData = {
        regionalPatrolId: this.addPatrolRegionData.regionalPatrolId
      };
      let res = await this.$Http.getOnePatrolRegion(paramData, true);
      if (res.code == 200) {
        // console.log(res)
        this.addPatrolRegionData = {
          regionalPatrolId: res.data.regionalPatrol.regionalPatrolId,
          regionalPatrolSite: res.data.regionalPatrol.regionalPatrolSite,
          codePictureNumber: res.data.regionalPatrol.codePictureNumber,
          qrCodeType: res.data.regionalPatrol.qrCodeType,
          flexTime: res.data.regionalPatrol.flexTime,
          nfc: res.data.regionalPatrol.nfc,
          nfcContent: res.data.regionalPatrol.nfcContent,
          routineInspectionContent: res.data.RoutineInspectionContent
        };
        this.showBox.showText = "编辑查询区域";
        this.dialog = true;
        // this.rightMenuClick(21,212)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    exportArea(){
          this.$refs.fileUpload.init()
    },
    cancelForm() {
      // this.loading = false;
      this.dialog = false;
      // this.editDialog = false,
      clearTimeout(this.timer);
    },
    // 打开预设事项
    openInspectionItems() {
      this.inspectionItemsOne();
      this.inspectionItemsTwo();
      // 预设事项框
      this.showBox.InspectionItemsBox = true;
      // 预设事项1
      this.showBox.InspectionItemsContent = 1;

      // console.log(this.getSaveData.selectArr)
      // console.log(this.getSaveData.selectArrName)
    },

    // 添加检查事项
    pushInspectionCate: function() {
      this.addPatrolRegionData.routineInspectionContent.push("");
      // console.log(this.addPatrolRegionData.routineInspectionContent)
    },
    // 删除检查事项
    deleteInspectionCate: function(obj1) {
      // console.log(obj2)
      // console.log(this.addPatrolRegionData.routineInspectionContent[obj1][obj2])
      this.addPatrolRegionData.routineInspectionContent.splice(obj1, 1);
      // console.log(this.addPatrolRegionData.routineInspectionContent)
    },

    // 更新检查事项
    updateInspectionCate: function(obj1, event) {
      // console.log(event.currentTarget.value)
      // console.log(this.addPatrolRegionData.routineInspectionContent)
      this.addPatrolRegionData.routineInspectionContent[obj1] =
        event.currentTarget.value;
      // console.log(this.addPatrolRegionData.routineInspectionContent[obj1])
    }
  },
  created() {},
  mounted() {
    this.getQueryRegion();
  }
};
</script>
<style lang="scss" scoped>
.task {
  max-height: 120px;
  word-break: break-all;
  overflow: scroll;
  .task-info {
    &:last-child {
      .comma {
        display: none;
      }
    }
    .task-name {
      color: #409eff;
    }
  }
}
</style>
